import { render, staticRenderFns } from "./DetailsCard.vue?vue&type=template&id=3ab40956&scoped=true"
import script from "./DetailsCard.vue?vue&type=script&lang=js"
export * from "./DetailsCard.vue?vue&type=script&lang=js"
import style0 from "./DetailsCard.vue?vue&type=style&index=0&id=3ab40956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab40956",
  null
  
)

export default component.exports